var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ad-image-container"},[_c('a',{attrs:{"href":_vm.useUrl(_vm.url),"rel":"noopener noreferrer","target":"_blank"}},[_c('img',{staticClass:"icon",attrs:{"src":_vm.useImage(_vm.image),"alt":""}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }